<template>
    <div id="rechargeB">
         <div class="header">
			<div class="access">
				<div>卡号</div>
				<div>{{ this.$store.state.recordLoginText }}</div>
			</div>
			<div class="access">
				<div>自动续费套餐</div>
				<div>{{ autoInfo.pkgName }}</div>
			</div>
            <div class="access">
				<div>续费状态</div>
				<div>{{ autoInfo.stateName }}</div>
			</div>
             <div> <span style="color:red" v-if="ishaveinfo"  @click="toRecharge() ">   更改续费套餐</span></div>
        </div> 
        <div class="packagePanel">
            <h1 class="package-title">选择流量包</h1>
            <div class="tabbar">
                <p :class="{'activeTab':tabbar==1}" @click="tabbarClick('1')">
					<span>基础套餐</span>
				</p>
            </div>
			<van-row>
			  <van-col span="12" class="package" v-for="item in simData" :key="item.id" @click="changeState(item,'1')" v-show="tabbar==1">
				<div class="package-name" :class="{'overlay-package':item.type == 11, 'label-defined-active':indexActive==item.id}"> 
					<!-- <h1 style="color: #07c160;" v-if="item.type == 11 ">{{item.packageName}}</h1> -->
					<h1>{{item.packageName}}</h1>
                    <p>{{item.remark}}</p>
					<p class="package-price">￥{{item.salePriceRmb}}元</p>
				</div>
				</van-col>
				<van-col span="12" class="package" v-for="item in simData2" :key="item.id" @click="changeState(item, 2)" v-show="tabbar==2">
					<!-- <span class="label-defined" :class="{'label-defined-active':indexActive2==item.id}">
						<label><van-icon name="success" color="#fff"/></label>
					</span> -->

					<div class="package-name" :class="{'label-defined-active':indexActive2==item.id}"> 
						<!-- <h1 style="color: #07c160;" v-if="item.type == 11 || item.type == 13 || item.type == 18|| item.type == 16||item.type == 19">{{item.packageName}}</h1> -->
						<h1>{{item.packageName}}</h1>
						<!-- 生效时间 -->
                          <p>{{item.remark}}</p>
						<!-- <p v-if="item.type==11">
							有效期：{{dateFormat('yyyy-MM-dd', new Date())}} 至 {{lastDayOfThisMonth()}}</p>
                        <p v-else >主套餐时间内无限叠加，加油包随基础套餐时间清零</p> -->
					
						<p class="package-price">￥{{item.salePriceRmb}}元</p>
					</div>
				</van-col>
			</van-row>
        </div>
        <Checkstand 
            :checkstandStyle="checkstandStyle"
            :dataToPay="dataToPay"
            :price="price" 
            :typeStyle="typeStyle"/>
        
        <div class="toRecharge">
           <p class="detail" style="color: red;">自动续费开启后，在套餐即将过期时，自动续订您选择的套餐。请保持您的余额充足，避免续费失败。</p>
            <div class="toRecharge-bottom">
                <p>金额：<span>{{money_format(price, 2, '.', ',')}} 元</span></p>
                 <div v-if="!ishaveinfo||!isOpen" class="toRechargeBtn" @click="toRecharge()  ">开启续费</div>
                   <div v-else-if="ishaveinfo&&autoInfo.state==0" class="toRechargeBtn" @click="toRecharge12()  ">关闭续费</div>
                     <div v-else-if="ishaveinfo&&autoInfo.state==1" class="toRechargeBtn" @click="toRecharge1()  ">开启续费</div>
            </div>
        </div>

            <!-- 密码框 -->
        <div class="van-overlay" style="z-index: 1999;" v-show="istosure"></div>
        <div class="van-popup van-popup--round van-popup--center passwordPanel" 
            style="z-index: 2000; min-height: 18%; min-width: 80%;"
            v-show="istosure"
            :style="{top:PasswordPanelTop+'%'}"
        >   
            
            <div class="cancelInput">
                <van-icon name="cross" @click="cancelInputPassword()"/>
            </div>
            <p>请输入支付密码</p>
            <h1>
                
            </h1>

            <!-- 密码输入框 -->
            <van-password-input
              :value="yuePayParam.payPass"
              :focused="showKeyboard"
              @focus="onfocus()"
            />

        
            
       </div>

        <van-overlay :show="overlay" z-index='2020'>
          <div class="wrapper" >
            <van-loading type="spinner" color="#fff" />
          </div>
        </van-overlay>
        <!-- 密码框  end -->

        <!-- 数字键盘 -->

        <van-number-keyboard id="keyboardDefined" 
          :z-index="2015"
          :show="showKeyboard"

          @input="onInput"
          @delete="onDelete"
          @blur="showKeyboard = false"
        />

        <div id="jdPayFormDiv"></div>

    </div>
</template>
<script>
import { wxRequest} from '@/api/user.js'
import { Dialog } from 'vant';
import { Toast } from 'vant';
import Checkstand from "@/components/Checkstand";

export default {
    components: {Checkstand},
    data(){
         return {
            thisCucc:0,
            indexActive: '',
            simData: [],
            autoInfo:'',
            isOpen:true,
            istosure:false,
            ishaveinfo:true,

            itemInfo: {
                supplierTypeName: localStorage.getItem('supplierTypeName'),
                flowRate: '',
                salePriceRmb: ''
            },
            isAdmin: '',
            globalIsAdmin: '',
            isNextMonth: '0',
            payType: 1,
            isNaturalMonth: false,
            showCheckstand: false,
            showMonthChoose: false,//判断是否显示本月次月

            //收银台
            checkstandStyle: {
                height: '50%',
                transition: '0.8s !important',
            },
            dataToPay: {},
            price:0,
            typeStyle: 1, //流量充值入口为1
            tabbar: 1,
            recordLoginText: localStorage.getItem('recordLoginText'),
            endTime: null, //判断年卡是否显示


            yuePayParam: {
                id: '', 
                payPass: '', 
                iccid: localStorage.getItem("iccid")
            },
            simData2: [],
            overlay: false,
            indexActive2: '',
            showKeyboard : false,
            showKeyboardZIndex:2015,
             PasswordPanelTop: 50,
              showPasswordPanel: false,
            itemInfo2: {
                supplierTypeName: '',
                flowRate: '',
                salePriceRmb: ''
            }
        }
    },
    methods: {
        // changeState(item){            
        //     this.indexActive = item.id;
        //     this.itemInfo = item; 
        //     this.price = item.salePriceRmb;

        //     if(item.isAdmin!=null&&
        //         item.isAdmin!=undefined&&
        //         item.isAdmin==1){
        //         this.isAdmin = item.isAdmin;
        //     }else{
        //         this.isAdmin = this.globalIsAdmin;
        //     }

        //     this.isNaturalMonth = item.type == 2 || item.type == 10? true : false; 
        //     this.showMonthChoose = item.type == 2 ? true : false; 
        // },
          cancelInputPassword(){
            this.yuePayParam.payPass = '';
            this.istosure = false;
        },
        
        onDelete() {
          this.yuePayParam.payPass = this.yuePayParam.payPass.slice(0, this.yuePayParam.payPass.length - 1);
        },
        onfocus(){
            this.showKeyboard = true;
            this.PasswordPanelTop = 30;
        },
        changeState(item, tabbar){
            if(tabbar == 1){
                this.indexActive = item.id;
                this.itemInfo = item; 
                this.price = item.salePriceRmb;
            }else {
                this.indexActive2 = item.id;
                this.itemInfo2 = item; 
                this.price = item.salePriceRmb;
            }
            
            if(item.isAdmin!=null&&
                item.isAdmin!=undefined&&
                item.isAdmin==1){
                this.isAdmin = item.isAdmin;
            }else{
                this.isAdmin = this.globalIsAdmin;
            }

            this.isNaturalMonth = item.type == 2 || item.type == 10 || item.type==14||item.type==6|| item.type==17|| item.type==25? true : false; 
            this.showMonthChoose = item.type == 2 || item.type == 10 || item.type==14|| item.type==17|| item.type==25? true : false; 
            this. isShowdetail= item.type == 2 || item.type == 10? true : false; 
        },

         toRecharge1(){
             var data = {
            iccid: this.$store.state.iccid,
            state:0
        }
             wxRequest("sim/user/sim/auto/state",data, "get").then(res => { 
                    this.$messagebox.alert(res.data.message);
                      location.reload()
                });
        },
              toRecharge12(){
             var data = {
            iccid: this.$store.state.iccid,
            state:1
        }
             wxRequest("sim/user/sim/auto/state",data, "get").then(res => { 
                    this.$messagebox.alert(res.data.message);
                      location.reload()
                });
        },
        toRecharge(){
            if(!this.isOpen){
                  Dialog.confirm({
                            title: '提示',
                            message:'当前卡号未开户,请开户后再进行此操作。 请点击【确认】前往开户'
                        }).then(() => {
                              this.$router.push({
                              path:'/user/cardSetUp',
                              query:{
                                  iccid:this.$store.state.iccid
                              }
                          });
                        }).catch(() => {

                        });
            }else{
                this.istosure=true;
            }
        },
         toRechargeSure(){

             var data = {                
                iccid: this.$store.state.iccid,
                soldPackageId: this.itemInfo.id,
                isAdmin: this.isAdmin,
                salePriceRmb: this.itemInfo.salePriceRmb,
            }
            let data2 = {                
                iccid: this.$store.state.iccid,
                soldPackageId: this.itemInfo2.id,
                isAdmin: this.isAdmin,
                salePriceRmb: this.itemInfo2.salePriceRmb,
            }

            //判断是否是月卡
            if(this.isNaturalMonth){
                data.isNextMonth = this.isNextMonth;
            }else{
                data.isNextMonth = '0';//万能卡
            }

            if(this.$store.state.source != false){
                data.source = this.$store.state.source;
            }else{
                data.source = 'xxgzh';
            }

            this.$store.state.showCheckstand = true;
            this.$store.state.showCheckstandSource = 'flowRecharge';
            if(this.tabbar == 1){
                this.dataToPay = data;
            }else {
                this.dataToPay = data2;
            }
            
        },
         onInput(key) {
            this.yuePayParam.payPass = (this.yuePayParam.payPass + key).slice(0, 6);
            if(this.yuePayParam.payPass.length >= 6){
                this.PasswordPanelTop = 50;
                this.yuePayParam.payPass = this.yuePayParam.payPass.slice(0, 6);
                this.overlay = true;
                this.yuePayParam.id= this.itemInfo.id;
                wxRequest("sim/user/sim/auto/open", this.yuePayParam, "get").then(res => { 
                    if(res.data.code == 200){
                        this.istosure=false;
                        this.yuePayParam.payPass = '';
                        this.overlay = false;
                        Toast.success(res.data.message);
                        location.reload()
                  }else{
                        this.overlay = false;
                        Dialog.alert({title: '提示', message: res.data.message}).then(action => {
                            this.yuePayParam.payPass = '';
                        }).catch(() => {});
                        
                    }
                });
            }
        },

        //第n天后
        afterManyDays(manyDays){
            let startTime = new Date();
            let startDate = new Date(startTime);
            startDate.setDate(startDate.getDate() + manyDays);
            return this.dateFormat('yyyy-MM-dd', startDate);
        },

        // 本月最后一天
        lastDayOfThisMonth(){
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth();
            return this.dateFormat('yyyy-MM-dd', new Date(year, month + 1, 0));
        },

        //下个月第一天
        firstDayOfNextMonth(){
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth();
            var day = date.getDate();

            let date2 = new Date(year, month + 1, 1)
            return this.dateFormat('yyyy-MM-dd', new Date(date2));
        },
        // 下个月最后一天
        lastDayOfNextMonth(){
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth();
            return this.dateFormat('yyyy-MM-dd', new Date(year, month + 2, 0));
        },

        changePayType(type){
            this.payType = type;
        },

        //点击tabbar
        tabbarClick(index){
            this.tabbar = index;
            if(this.simData.length != 0 && index == '1'){
                this.indexActive = this.simData[0].id;
                this.price = this.simData[0].salePriceRmb;
                this.itemInfo = this.simData[0];
				this.changeState(this.itemInfo,index)
            }else if(this.simData2.length != 0 && index == '2'){
                this.indexActive2 = this.simData2[0].id;
                this.price = this.simData2[0].salePriceRmb;
                this.itemInfo2 = this.simData2[0];
				this.changeState(this.itemInfo2,index)
            }
        }
    },
    created(){
        var data = {
            iccid: this.$store.state.iccid
        }
         wxRequest("sim/user/sim/auto", data, "get").then(res => {
            if(res.data.code==402){
                this.isOpen=false;
                 Dialog.confirm({
                            title: '提示',
                            message:'当前卡号未开户,请开户后再进行此操作。 请点击【确认】前往开户'
                        }).then(() => {
                               this.$router.push({
                              path:'/user/cardSetUp',
                              query:{
                                  iccid:this.$store.state.iccid
                              }
                          });
                        }).catch(() => {

                        });
            }else  if(res.data.code==200){
                this.autoInfo=res.data.data;
            }else{
                this.ishaveinfo=false;
            }
        });
        wxRequest("sim/user/soldPkg/auto", data, "get").then(res => {
            var result = res.data.data;
            if(res.data.code == 200 && result.list.length > 0){
                this.endTime = result.endTime;
                let resultArray1 = [];
                let resultArray2 = [];
                for(let i=0; i<result.list.length; i++){
                     console.log('当前type'+result.list[i].type);
                    if(result.list[i].type == 17||result.list[i].type == 14){
                        this.thisCucc=1
                    }

                    // if(result.list[i].type == 11 || result.list[i].type == 13){
                    //     resultArray1.push(result.list[i]);
                    // }else if(result.list[i].type == 7 || result.list[i].type == 8 || result.list[i].type == 9){
                    //     resultArray2.unshift(result.list[i]);
                    // }else {
                    //     resultArray1.unshift(result.list[i]);
                    // }
                    if(result.list[i].type == 1 || result.list[i].type == 4 || result.list[i].type == 11 || result.list[i].type == 13 || result.list[i].type == 16 ||result.list[i].type == 18 ||result.list[i].type == 19){
                        this.simData2.push(result.list[i])
                        this.simData2.sort((a,b) => b.flowRate - a.flowRate)
                    }else {
                        if(result.list[i].type == 7 || result.list[i].type == 8 || result.list[i].type == 9){
                            if(!this.endTime){
                                resultArray2.push(result.list[i])
                            }
                        }else {
                            if(result.list[i].packageName.includes('200')){
                                resultArray1.push(result.list[i])
                            }else {
                                resultArray1.unshift(result.list[i])
                            }
                        }
                    }
                }
                 /**每月倒数第6天默认选中次月生效**/
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth();
        var day = date.getDate();
        console.log('当前日期'+day);
         console.log('当前cucc'+this.thisCucc);
        var date2 = new Date(year, month + 1, 0)
        var endDay = date2.getDate();
        if(this.thisCucc==0){
            day >= endDay - 8 ? this.isNextMonth = '1' : this.isNextMonth = '0';
        }else{
            if(day>=21&&day<=26){
                 console.log('当前本月'+day);
                this.isNextMonth ='1'
            }else{
                console.log('当前次月'+day);
                this.isNextMonth= '0'
            }
        }

                this.simData = resultArray1.concat(resultArray2);
                this.isAdmin = result.isAdmin;
                this.globalIsAdmin = result.isAdmin;
                this.isNaturalMonth = this.simData[0].type == 2 || this.simData[0].type == 10 || this.simData[0].type == 14|| this.simData[0].type == 6
                || this.simData[0].type == 25? true : false; 
                this.simData.sort((a,b) => b.flowRate - a.flowRate);
                this.indexActive = this.simData[0].id;
                this.price = this.simData[0].salePriceRmb;
                this.itemInfo = this.simData[0];
               
                
            }
        })

       
    }
}
</script>
<style lang="less" scoped>

#rechargeB {
    background: #FAFAFA;
	height: calc(100% - 104px);
	overflow: auto;
    .header {
        padding: 10px 16px;
        background: #fff;
        margin-bottom: 10px;
		.access{
			display: flex;
			width: 100%;
			line-height:54px;
			font-size: .975rem;
			div{
				flex: 1;
				color:#333;
				text-align: right;
			}
			div:first-child{
				color: #96989D;
				text-align:left;
			}
		}
		.access:nth-child(2){
			border-bottom:1px solid #F0F0F0;
			border-top:1px solid #F0F0F0;
		}
    } 

    
    .packagePanel {
        padding: 5px 16px;
		// background: #282E3E;
        .tabbar {
            display: flex;
            height: 40px;
            margin-bottom: 10px;
            p {
                flex: 1;
                height: inherit;
                text-align: center;
				font-size:1rem;
				line-height:40px;
				color:#666;
            }
            .activeTab {
				span{
					border-bottom: 2px solid #24BAC8;
					line-height:40px;
					display: inline-block;
					color:#24BAC8;
				}
            }
        }

        .package-title{
            padding: 10px 0px;
            color: #333;
            font-weight:bold;
        }

        .package{
            // flex:1;
			padding: 10px 5px;
            position: relative;

            .label-defined{
                display: block;
                border-width: 14px 18px 14px 18px;
                border-style: solid;
                border-color: transparent;
                position: absolute;  

                label{
                    position: absolute;
                    left: -14px;
                    top: -12px;
                    background: transparent;
                } 
            }
            .package-name{
                flex-grow: 1;
                padding: 5px 10px;
                background: #fff;
				border-radius:10px;
                h1{
                    margin:14px 0;
                    color: #3F3E43;
                    font-size:1rem;
					text-align: center;
					line-height:20px;
                }
                p{
                    margin: 10px 0;
                    color: #96989D;
					line-height:20px;
                    font-size:13px;
                }
            }
			.label-defined-active{
			    background: #24BAC8 url(../../assets/home/active.png) no-repeat right bottom;
				h1{
				    color:#fff;
				}
				p{
				    color: #fff;
				}
				p.package-price{
					color: #fff;
				}
			}

            p.package-price{
                flex-grow: 0;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				color: #24BAC8;
				font-size: 1.125rem;
            }

            .package-price.overlay-package{
                border-color: #07c160;
                background: #07c160;
            }
            
        }

    }

	


    .toRecharge{
        position: fixed;
        width: 100%;
        bottom: 0;
        font-size: 16px;
		background: #fff;
        .toRecharge-top{
            display: flex;
            .radio-group-defined{
                display: flex;
                padding-left: 20px;
                justify-content: center;
                align-items: center;
				border-bottom: 1px solid #eee;
                height: 34px;
				/deep/.van-radio__icon--checked{
					.van-icon-success{
						background-color: #24BAC8 !important;
						border-color: #24BAC8 !important;
					}
				}
				/deep/.van-radio__label{
					color:#666;
					margin-left:0px
				}
                div{
                    height: 20px;
                    margin-right: 15px;
                }
            }

        }

        .detail {
            color: #96989D;
			font-size: 12px;
            padding-left: 20px;
            padding-top: 5px;
        }

        .toRecharge-bottom{
            display: flex;
			line-height:46px;
            p{
                padding-right: 15px;
                flex-grow: 1;
                color: #333333;
                background:#fff;
                text-align: left;
				line-height:46px;
				padding-left:10px;
                span{
                    color: #FB4D07;
					font-size:1.25rem;
					vertical-align: middle;
                }
            }

            .toRechargeBtn{
                padding: 0 60px;
                display: inline-block;
                line-height: 46px;
                flex-grow: 0;
                color: #fff;
                background: #24BAC8;
            }
        }

    }
}
</style>
